import dayjs from 'dayjs';

// export const durationOptions = [
//   { label: '30 minutes', value: '30' },
//   { label: '1 hour', value: '60' },
//   { label: '1 hour 30 minutes', value: '90' },
//   { label: '2 hour', value: '120' },
//   { label: '2 hour 30 minutes', value: '150' },
//   { label: '3 hour', value: '180' },
// ];

export const durationOptions = [
  { label: '30 minutes', value: 30 },
  { label: '1 hour', value: 60 },
  { label: '1 hour 30 minutes', value: 90 },
  { label: '2 hour', value: 120 },
  { label: '2 hour 30 minutes', value: 150 },
  { label: '3 hour', value: 180 },
];


export const generateTimeSlots = () => {
  const slots: { key: string; value: string }[] = [];

  for (let hour = 0; hour < 24; hour++) {
    for (let min = 0; min < 60; min += 30) {
      const time24 = dayjs().hour(hour).minute(min).format('HH:mm'); // 24-hr format
      const time12 = dayjs().hour(hour).minute(min).format('hh:mm A'); // 12-hr format
      slots.push({ key: time12, value: time24 });
    }
  }

  return slots;
};
